import { FC } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { HoroscopeIconType } from '../../Horoscopes/HoroscopesIcon/HoroscopesIcon-Constants';
import HoroscopesCard from '../HoroscopesCard/HoroscopesCard';
import { useTranslation } from 'react-i18next';
import { getTranslatedDateRange } from '../HoroscopesV2Util';
import 'swiper/css';
import './HoroscopesGrid.scss';

interface HoroscopesGridProps {
  horoscopes: Array<{
    sign: HoroscopeIconType;
    text: string;
  }>;
  onCardClick?: (sign: HoroscopeIconType) => void;
  className?: string;
}

export const HoroscopesGrid: FC<HoroscopesGridProps> = ({ horoscopes, onCardClick, className = '' }) => {
  const { t } = useTranslation();

  const handleCardClick = (sign: HoroscopeIconType) => {
    if (onCardClick) {
      onCardClick(sign);
    }
  };

  return (
    <div className={`horoscopes-v2-grid ${className}`}>
      <Swiper
        slidesPerView={1.5}
        spaceBetween={12}
        className="horoscopes-v2-grid__swiper"
        breakpoints={{
          320: {
            slidesPerView: 1.2,
            spaceBetween: 24,
          },
          640: {
            slidesPerView: 1.5,
            spaceBetween: 24,
          },
          1024: {
            slidesPerView: 1.5,
            spaceBetween: 24,
          },
        }}
      >
        {horoscopes.map((horoscope, index) => (
          <SwiperSlide key={`${horoscope.sign}-${index}`} className="horoscopes-v2-grid__slide">
            <HoroscopesCard
              sign={horoscope.sign}
              date={getTranslatedDateRange(horoscope.sign, t)}
              text={horoscope.text}
              onClick={() => handleCardClick(horoscope.sign)}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default HoroscopesGrid;

